export function playSound (sound) {
  let audio = new Audio(require('@/sfx/' + sound + '.wav'))
  audio.play()
}
